import Flex from '@/component/atom/Flex';
import { $k18n } from '@/common/i18n';
import { Popup } from '@kibt/meta-ui-krn';
import React from 'react';
import { Text, StyleSheet, View } from 'react-native';
import { styleGlobal, styles, vh } from '@/common/style';
import IconArrowRight from '@/assets/icon/arrow_right_grey.png';
import { vIf } from '@/common/utils/vIf';
import Image from '@kds/image';
import { useCoudanInfoStore } from '../coudanInfoStore';
import { useFixedPosition } from '@/hooks/useFixedPosition';
import { isFixedViewSupport } from '@/component/FixedView';
import { KTouchableOpacity } from '@/component/RtlLayout/Touchable';

const pureStyle = {
    content: {
        backgroundColor: '#fff',
        height: vh(80),
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
    },
};
const style = StyleSheet.create({"title":{"fontWeight":"bold","fontSize":"4.830917874396135rem","flex":1,"textAlign":"center","color":"rgba(0, 0, 0, 0.88)"},"closeIcon":{"width":"5.797101449275363rem","height":"5.797101449275363rem"},"discountText":{"marginRight":"1.2077294685990339rem"}});
export function CheckoutDetailPopup() {
    const { checkOutDetail, checkoutDetailVisible, showDiscountDetail } = useCoudanInfoStore(s => ({
        checkOutDetail: s.checkOutDetail,
        checkoutDetailVisible: s.checkoutDetailVisible,
        showDiscountDetail: s.showDiscountDetail,
    }));
    const setStore = useCoudanInfoStore().setState;

    const position = useFixedPosition();

    return (
        <View style={{ zIndex: 999, position, backgroundColor: 'red' }}>
            <Popup
                visible={checkoutDetailVisible}
                maskZindex={888}
                onClose={() => {
                    setStore({ checkoutDetailVisible: false });
                }}
                position="bottom"
                boxStyle={!isFixedViewSupport ? { position } : {}}>
                <Flex style={{ ...pureStyle.content }} flex={'flexCol'}>
                    <Flex
                        style={{"alignItems":"center","paddingHorizontal":"4.5893719806763285rem","paddingVertical":16,"borderBottomWidth":0.5,"borderColor":"#EAEAEA"}}
                        flex={'flexBtw'}>
                        <Text style={style.title}>{$k18n('优惠明细')}</Text>
                    </Flex>
                    <Flex flex={'flexCol'} style={{"padding":"4.5893719806763285rem"}}>
                        <Flex flex={'flexBtw'}>
                            <Text style={styles({ color: '#000' })}>{$k18n('商品总价')}</Text>
                            <Text style={styles({ color: '#000' })}>{checkOutDetail?.productSubtotalAmount?.displayAmount}</Text>
                        </Flex>
                        <Flex flex={'flexBtw'} style={{"marginVertical":"4.1062801932367154rem"}}>
                            <Text style={styles({ color: '#000' })}>{$k18n('总折扣')}</Text>
                            <KTouchableOpacity activeOpacity={0.6} onPress={() => setStore({ showDiscountDetail: !showDiscountDetail })}>
                                <Flex flex={'flexRowCenter'}>
                                    <Text style={[style.discountText, styleGlobal.primaryColor]}>
                                        -{checkOutDetail?.totalDiscountAmount?.displayAmount}
                                    </Text>
                                    {!!checkOutDetail?.productTotalDiscountAmount?.amount || !!checkOutDetail?.productCouponDiscountAmount?.amount ? (
                                        <Image
                                            style={styles({
                                                width: 16,
                                                height: 16,
                                                transform: [{ rotate: showDiscountDetail ? '-90deg' : '90deg' }],
                                            })}
                                            source={IconArrowRight}
                                        />
                                    ) : null}
                                </Flex>
                            </KTouchableOpacity>
                        </Flex>

                        {showDiscountDetail ? (
                            <>
                                {vIf(
                                    [!!checkOutDetail?.productTotalDiscountAmount?.amount],
                                    <Flex flex={'flexBtw'} style={{"marginBottom":"4.1062801932367154rem"}}>
                                        <Text style={styles({ color: '#999' })}>{$k18n('商品折扣')}</Text>
                                        <Text style={styleGlobal.primaryColor}>-{checkOutDetail?.productTotalDiscountAmount?.displayAmount}</Text>
                                    </Flex>
                                )}
                                {vIf(
                                    [!!checkOutDetail?.productCouponDiscountAmount?.amount],
                                    <Flex flex={'flexBtw'} style={{"marginBottom":"4.1062801932367154rem"}}>
                                        <Text style={styles({ color: '#999' })}>{$k18n({ text: '优惠券', desc: 'C补-运费券' })}</Text>
                                        <Text style={styleGlobal.primaryColor}>-{checkOutDetail?.productCouponDiscountAmount?.displayAmount}</Text>
                                    </Flex>
                                )}
                            </>
                        ) : null}

                        <Flex flex={'flexBtw'}>
                            <Text style={styles({ color: '#000' })}>{$k18n('合计金额')}</Text>
                            <Text style={styles({ color: 'rgba(0, 0, 0, 0.88)' })}>{checkOutDetail?.productTotalPayment?.displayAmount}</Text>
                        </Flex>
                    </Flex>
                </Flex>
            </Popup>
        </View>
    );
}
